import { graphql } from "relay-runtime"

export const chAiSuggestionsQueryDef = graphql`
  query chEpisodeOfCareAiSuggestionsQuery($appointmentId: ID!) {
    suggestedEpisodeOfCareIcdDiagnoses: ch_suggestedEpisodeOfCareIcdDiagnoses(appointmentId: $appointmentId) {
      diagnosisCode
      id
      text
    }
  }
`
